// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "sites/v1/service.proto" (package "sites.v1", syntax proto3)
// tslint:disable
import { CircuitDeviceService } from "./service.js";
import { CircuitNodeService } from "./service.js";
import { CircuitService } from "./service.js";
import { DeliveryPointService } from "./service.js";
import { SiteService } from "./service.js";
import { DsoService } from "./service.js";
import { TsoService } from "./service.js";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * Services
 * TsoService manages Transmission System Operators (TSOs) that operate high-voltage transmission networks
 *
 * @generated from protobuf service sites.v1.TsoService
 */
export class TsoServiceClient {
    _transport;
    typeName = TsoService.typeName;
    methods = TsoService.methods;
    options = TsoService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListTsos retrieves a paginated list of TSOs with optional filtering by country and area
     *
     * @generated from protobuf rpc: ListTsos
     */
    listTsos(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateTso creates a new TSO with the specified details
     *
     * @generated from protobuf rpc: CreateTso
     */
    createTso(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetTso retrieves a specific TSO by its unique identifier
     *
     * @generated from protobuf rpc: GetTso
     */
    getTso(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateTso modifies an existing TSO's properties
     *
     * @generated from protobuf rpc: UpdateTso
     */
    updateTso(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteTso performs a soft or permanent delete of a TSO
     *
     * @generated from protobuf rpc: DeleteTso
     */
    deleteTso(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * RestoreTso restores a soft-deleted TSO
     *
     * @generated from protobuf rpc: RestoreTso
     */
    restoreTso(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * DsoService manages Distribution System Operators (DSOs) that operate medium and low-voltage distribution networks
 *
 * @generated from protobuf service sites.v1.DsoService
 */
export class DsoServiceClient {
    _transport;
    typeName = DsoService.typeName;
    methods = DsoService.methods;
    options = DsoService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListDsos retrieves a paginated list of DSOs with optional filtering by country code and area
     *
     * @generated from protobuf rpc: ListDsos
     */
    listDsos(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateDso creates a new DSO with the specified details
     *
     * @generated from protobuf rpc: CreateDso
     */
    createDso(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetDso retrieves a specific DSO by its unique identifier
     *
     * @generated from protobuf rpc: GetDso
     */
    getDso(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateDso modifies an existing DSO's properties
     *
     * @generated from protobuf rpc: UpdateDso
     */
    updateDso(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteDso permanently deletes a DSO
     *
     * @generated from protobuf rpc: DeleteDso
     */
    deleteDso(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * SiteService manages physical sites where charging infrastructure is deployed
 *
 * @generated from protobuf service sites.v1.SiteService
 */
export class SiteServiceClient {
    _transport;
    typeName = SiteService.typeName;
    methods = SiteService.methods;
    options = SiteService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListSites retrieves a paginated list of sites with optional filtering by location
     *
     * @generated from protobuf rpc: ListSites
     */
    listSites(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateSite creates a new site with the specified location and configuration details
     *
     * @generated from protobuf rpc: CreateSite
     */
    createSite(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetSite retrieves a specific site by its unique identifier, including associated delivery points
     *
     * @generated from protobuf rpc: GetSite
     */
    getSite(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateSite modifies an existing site's properties such as location, status, or configuration
     *
     * @generated from protobuf rpc: UpdateSite
     */
    updateSite(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteSite performs a soft delete of a site by marking it as deleted
     *
     * @generated from protobuf rpc: DeleteSite
     */
    deleteSite(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * DeliveryPointService manages electrical delivery points that connect sites to the distribution network
 *
 * @generated from protobuf service sites.v1.DeliveryPointService
 */
export class DeliveryPointServiceClient {
    _transport;
    typeName = DeliveryPointService.typeName;
    methods = DeliveryPointService.methods;
    options = DeliveryPointService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListDeliveryPoints retrieves a paginated list of delivery points with optional filtering by site
     *
     * @generated from protobuf rpc: ListDeliveryPoints
     */
    listDeliveryPoints(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateDeliveryPoint creates a new delivery point with specified power limits and connection details
     *
     * @generated from protobuf rpc: CreateDeliveryPoint
     */
    createDeliveryPoint(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetDeliveryPoint retrieves a specific delivery point by its unique identifier, including associated circuits
     *
     * @generated from protobuf rpc: GetDeliveryPoint
     */
    getDeliveryPoint(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateDeliveryPoint modifies an existing delivery point's power limits or connection configuration
     *
     * @generated from protobuf rpc: UpdateDeliveryPoint
     */
    updateDeliveryPoint(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteDeliveryPoint performs a soft delete of a delivery point by marking it as deleted
     *
     * @generated from protobuf rpc: DeleteDeliveryPoint
     */
    deleteDeliveryPoint(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * CircuitService manages electrical circuits within delivery points that distribute power to charging stations
 *
 * @generated from protobuf service sites.v1.CircuitService
 */
export class CircuitServiceClient {
    _transport;
    typeName = CircuitService.typeName;
    methods = CircuitService.methods;
    options = CircuitService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListCircuits retrieves a paginated list of circuits with optional filtering by delivery point
     *
     * @generated from protobuf rpc: ListCircuits
     */
    listCircuits(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateCircuit creates a new circuit with specified power limits and phase configuration
     *
     * @generated from protobuf rpc: CreateCircuit
     */
    createCircuit(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetCircuit retrieves a specific circuit by its unique identifier, including hierarchical relationships
     *
     * @generated from protobuf rpc: GetCircuit
     */
    getCircuit(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateCircuit modifies an existing circuit's power limits, phase configuration, or active status
     *
     * @generated from protobuf rpc: UpdateCircuit
     */
    updateCircuit(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteCircuit performs a soft delete of a circuit by marking it as deleted
     *
     * @generated from protobuf rpc: DeleteCircuit
     */
    deleteCircuit(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * CircuitNodeService manages hierarchical relationships between circuits, enabling circuit trees and dependencies
 *
 * @generated from protobuf service sites.v1.CircuitNodeService
 */
export class CircuitNodeServiceClient {
    _transport;
    typeName = CircuitNodeService.typeName;
    methods = CircuitNodeService.methods;
    options = CircuitNodeService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListCircuitNodes retrieves parent-child relationships between circuits with optional filtering
     *
     * @generated from protobuf rpc: ListCircuitNodes
     */
    listCircuitNodes(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateCircuitNode establishes a parent-child relationship between two circuits
     *
     * @generated from protobuf rpc: CreateCircuitNode
     */
    createCircuitNode(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetCircuitNode retrieves a specific circuit node relationship by its unique identifier
     *
     * @generated from protobuf rpc: GetCircuitNode
     */
    getCircuitNode(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteCircuitNode removes a parent-child relationship between circuits
     *
     * @generated from protobuf rpc: DeleteCircuitNode
     */
    deleteCircuitNode(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * CircuitDeviceService manages the connections between devices and electrical circuits
 *
 * @generated from protobuf service sites.v1.CircuitDeviceService
 */
export class CircuitDeviceServiceClient {
    _transport;
    typeName = CircuitDeviceService.typeName;
    methods = CircuitDeviceService.methods;
    options = CircuitDeviceService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * ListCircuitDevices retrieves device-to-circuit connections with optional filtering by circuit or device
     *
     * @generated from protobuf rpc: ListCircuitDevices
     */
    listCircuitDevices(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateCircuitDevice connects a device to a circuit with specified phase and priority configuration
     *
     * @generated from protobuf rpc: CreateCircuitDevice
     */
    createCircuitDevice(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetCircuitDevice retrieves a specific circuit-device connection by its unique identifier
     *
     * @generated from protobuf rpc: GetCircuitDevice
     */
    getCircuitDevice(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateCircuitDevice modifies the phase configuration or priority of a circuit-device connection
     *
     * @generated from protobuf rpc: UpdateCircuitDevice
     */
    updateCircuitDevice(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteCircuitDevice removes a device from a circuit by marking the connection as deleted
     *
     * @generated from protobuf rpc: DeleteCircuitDevice
     */
    deleteCircuitDevice(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
//# sourceMappingURL=service.client.js.map